import Messages from './protocols_messages';

export enum NetworkProtocol {
  IPV4 = 'ipv4',
  IPV6 = 'ipv6',
}

export const fromNetworkProtocolNumberMap = new Map<number, NetworkProtocol>([
  [2, NetworkProtocol.IPV4],
  [23, NetworkProtocol.IPV6],
]);

export function fromNetworkProtocolNumber(network: number): NetworkProtocol|null {
  return fromNetworkProtocolNumberMap.get(network) ?? null;
}

export const ORDERED_NETWORKS: readonly NetworkProtocol[] = [
  NetworkProtocol.IPV4,
  NetworkProtocol.IPV6,
];

export function getFullNetworkProtocol(network: NetworkProtocol|null) {
  switch(network) {
    case NetworkProtocol.IPV4:
      return Messages.networkIpv4Full();
    case NetworkProtocol.IPV6:
      return Messages.networkIpv6Full();
    default:
      return Messages.networkUnknownFull();
  }
}

export function getShortNetworkProtocol(network: NetworkProtocol|null) {
  switch(network) {
    case NetworkProtocol.IPV4:
      return Messages.networkIpv4Short();
    case NetworkProtocol.IPV6:
      return Messages.networkIpv6Short();
    default:
      return Messages.networkUnknownShort();
  }
}

export enum TransportProtocol {
  ICMP = 'icmp',
  IGMP = 'igmp',
  TCP  = 'tcp',
  UDP  = 'udp',
  DCCP = 'dccp',
}

export const fromTransportProtocolNumberMap = new Map<number, TransportProtocol>([
  [1, TransportProtocol.ICMP],
  [2, TransportProtocol.IGMP],
  [6, TransportProtocol.TCP],
  [17, TransportProtocol.UDP],
  [33, TransportProtocol.DCCP],
]);

export function fromTransportProtocolNumber(transport: number): TransportProtocol|null {
  return fromTransportProtocolNumberMap.get(transport) ?? null;
}

export const ORDERED_TRANSPORTS: readonly TransportProtocol[] = [
  TransportProtocol.ICMP,
  TransportProtocol.IGMP,
  TransportProtocol.TCP,
  TransportProtocol.UDP,
  TransportProtocol.DCCP,
];

export function getFullTransportProtocol(transport: TransportProtocol|null) {
  switch(transport) {
    case TransportProtocol.ICMP:
      return Messages.transportIcmpFull();
    case TransportProtocol.IGMP:
      return Messages.transportIgmpFull();
    case TransportProtocol.TCP:
      return Messages.transportTcpFull();
    case TransportProtocol.UDP:
      return Messages.transportUdpFull();
    case TransportProtocol.DCCP:
      return Messages.transportDccpFull();
    default:
      return Messages.transportUnknownFull();
  }
}

export function getShortTransportProtocol(transport: TransportProtocol|null) {
  switch(transport) {
    case TransportProtocol.ICMP:
      return Messages.transportIcmpShort();
    case TransportProtocol.IGMP:
      return Messages.transportIgmpShort();
    case TransportProtocol.TCP:
      return Messages.transportTcpShort();
    case TransportProtocol.UDP:
      return Messages.transportUdpShort();
    case TransportProtocol.DCCP:
      return Messages.transportDccpShort();
    default:
      return Messages.transportUnknownShort();
  }
}

export enum ApplicationProtocol {
  FTP     = 'ftp',
  SSH     = 'ssh',
  TELNET  = 'telnet',
  SMTP    = 'smtp',
  DNS     = 'dns',
  DHCP    = 'dhcp',
  TFTP    = 'tftp',
  HTTP    = 'http',
  POP2    = 'pop2',
  POP3    = 'pop3',
  NTP     = 'ntp',
  NETBIOS = 'netbios',
  IMAP    = 'imap',
  HTTPS   = 'https',
}

export const ORDERED_APPLICATION_PROTOCOLS: readonly ApplicationProtocol[] = [
  ApplicationProtocol.FTP,
  ApplicationProtocol.SSH,
  ApplicationProtocol.TELNET,
  ApplicationProtocol.SMTP,
  ApplicationProtocol.DNS,
  ApplicationProtocol.DHCP,
  ApplicationProtocol.TFTP,
  ApplicationProtocol.HTTP,
  ApplicationProtocol.POP2,
  ApplicationProtocol.POP3,
  ApplicationProtocol.NTP,
  ApplicationProtocol.NETBIOS,
  ApplicationProtocol.IMAP,
  ApplicationProtocol.HTTPS,
];

export function getFullApplicationProtocol(application: ApplicationProtocol|null) {
  switch(application) {
    case ApplicationProtocol.FTP:
      return Messages.applicationFtpFull();
    case ApplicationProtocol.SSH:
      return Messages.applicationSshFull();
    case ApplicationProtocol.TELNET:
      return Messages.applicationTelnetFull();
    case ApplicationProtocol.SMTP:
      return Messages.applicationSmtpFull();
    case ApplicationProtocol.DNS:
      return Messages.applicationDnsFull();
    case ApplicationProtocol.DHCP:
      return Messages.applicationDhcpFull();
    case ApplicationProtocol.TFTP:
      return Messages.applicationTftpFull();
    case ApplicationProtocol.HTTP:
      return Messages.applicationHttpFull();
    case ApplicationProtocol.POP2:
      return Messages.applicationPop2Full();
    case ApplicationProtocol.POP3:
      return Messages.applicationPop3Full();
    case ApplicationProtocol.NTP:
      return Messages.applicationNtpFull();
    case ApplicationProtocol.NETBIOS:
      return Messages.applicationNetbiosFull();
    case ApplicationProtocol.IMAP:
      return Messages.applicationImapFull();
    case ApplicationProtocol.HTTPS:
      return Messages.applicationHttpsFull();
    default:
      return Messages.applicationUnknownFull();
  }
}

export function getShortApplicationProtocol(application: ApplicationProtocol|null) {
  switch(application) {
    case ApplicationProtocol.FTP:
      return Messages.applicationFtpShort();
    case ApplicationProtocol.SSH:
      return Messages.applicationSshShort();
    case ApplicationProtocol.TELNET:
      return Messages.applicationTelnetShort();
    case ApplicationProtocol.SMTP:
      return Messages.applicationSmtpShort();
    case ApplicationProtocol.DNS:
      return Messages.applicationDnsShort();
    case ApplicationProtocol.DHCP:
      return Messages.applicationDhcpShort();
    case ApplicationProtocol.TFTP:
      return Messages.applicationTftpShort();
    case ApplicationProtocol.HTTP:
      return Messages.applicationHttpShort();
    case ApplicationProtocol.POP2:
      return Messages.applicationPop2Short();
    case ApplicationProtocol.POP3:
      return Messages.applicationPop3Short();
    case ApplicationProtocol.NTP:
      return Messages.applicationNtpShort();
    case ApplicationProtocol.NETBIOS:
      return Messages.applicationNetbiosShort();
    case ApplicationProtocol.IMAP:
      return Messages.applicationImapShort();
    case ApplicationProtocol.HTTPS:
      return Messages.applicationHttpsShort();
    default:
      return Messages.applicationUnknownShort();
  }
}
